import { getExternalAccountsQueryOptions } from '@features/accounts/api/external-accounts/get-external-accounts';
import { ExternalAccount } from '@features/accounts/types';
import { createFileRoute, notFound } from '@tanstack/react-router';
import ExternalSettingsLayout from './-external-settings-layout';

export const Route = createFileRoute(
  '/_authenticated/dashboard/external/$accountId/settings',
)({
  loader: async ({
    context,
    params,
  }): Promise<{ account: ExternalAccount }> => {
    const externalAccounts = await context.queryClient.ensureQueryData({
      queryKey: getExternalAccountsQueryOptions.queryKey,
      queryFn: getExternalAccountsQueryOptions.queryFn,
    });

    const account = externalAccounts?.find(
      (acc) => acc.uuid === params.accountId,
    );

    if (!account) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }

    return { account };
  },
  component: ExternalSettingsLayout,
});
